import { of, concat } from 'rxjs';
import { takeUntil, ignoreElements } from 'rxjs/operators';
export var takeUntilComplete = function (notifier) {
    return takeUntil(concat(notifier.pipe(ignoreElements()), of(undefined)));
};
//# sourceMappingURL=takeUntilComplete.js.map